import { EUserType } from 'services/BackendApi';

export const userTypesOptions = [
  {
    label: 'Finance',
    value: EUserType.FINANCE,
  },
  {
    label: 'Sales Representative',
    value: EUserType.SR,
  },
  {
    label: 'Admin',
    value: EUserType.ADMIN,
  },
  {
    label: 'Rate Loader',
    value: EUserType.RL,
  },
  {
    label: 'Sales',
    value: EUserType.SALES,
  },
  {
    label: 'Marketing',
    value: EUserType.MARKETING,
  },
  {
    label: 'Ground Operator',
    value: EUserType.GROUND_OPERATOR,
  },
];

// Roles that work a set of destinations, assigned on the internal user page (OWA-12056).
export const DESTINATION_ASSIGNABLE_USER_TYPES: EUserType[] = [EUserType.SR, EUserType.GROUND_OPERATOR];

export const canHaveAssignedDestinations = (type?: EUserType | null): boolean =>
  !!type && DESTINATION_ASSIGNABLE_USER_TYPES.includes(type);
